
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.695 4.92V19.09H3.295V4.92H20.695ZM20.875 3.12H3.115C2.685 3.12 2.275 3.29 1.975 3.59C1.675 3.89 1.505 4.3 1.505 4.73V19.27C1.505 19.7 1.675 20.11 1.975 20.41C2.275 20.71 2.685 20.88 3.115 20.88H20.885C21.315 20.88 21.725 20.71 22.025 20.41C22.325 20.11 22.495 19.7 22.495 19.27V4.74C22.495 4.31 22.325 3.9 22.025 3.6C21.725 3.3 21.315 3.13 20.885 3.13L20.875 3.12Z","fill":"#16171F"}}),_c('path',{attrs:{"d":"M20.875 3.12H3.115C2.685 3.12 2.275 3.29 1.975 3.59C1.675 3.89 1.505 4.3 1.505 4.73V19.27C1.505 19.7 1.675 20.11 1.975 20.41C2.275 20.71 2.685 20.88 3.115 20.88H20.885C21.315 20.88 21.725 20.71 22.025 20.41C22.325 20.11 22.495 19.7 22.495 19.27V4.74C22.495 4.31 22.325 3.9 22.025 3.6C21.725 3.3 21.315 3.13 20.885 3.13L20.875 3.12Z","fill":"#5D5CFD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.95493 7.47C8.45199 7.47 8.85493 7.87294 8.85493 8.37C8.85493 10.1029 10.262 11.51 11.9949 11.51C13.7279 11.51 15.1349 10.1029 15.1349 8.37C15.1349 7.87294 15.5379 7.47 16.0349 7.47C16.532 7.47 16.9349 7.87294 16.9349 8.37C16.9349 11.0971 14.722 13.31 11.9949 13.31C9.26787 13.31 7.05493 11.0971 7.05493 8.37C7.05493 7.87294 7.45788 7.47 7.95493 7.47Z","fill":"white"}})])
          )
        }
      }
    